import React from 'react';
import styles from './styles.css';

const { getEnvName } = require('../../../lib/bputils').default;

class ScreenSizeIndicator extends React.Component {
  screenSizeIndicatorDiv = React.createRef();

  state = {
    top: 0,
  }

  componentDidMount() {
    if (getEnvName() === 'production') {
      return;
    }
    window.addEventListener('scroll', this.handleScroll, true);
  }

  componentWillUnmount() {
    if (getEnvName() === 'production') {
      return;
    }
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    this.setState(() => ({ top: window.scrollY }));
  }

  render = () => {
    if (getEnvName() === 'production') {
      return null;
    }

    const { top } = this.state;
    const scrolled = `; Scrolled: ${Math.round(top)}`;

    return (
      <div
        ref={this.screenSizeIndicatorDiv}
        className={styles.screenSizeIndicator}
        style={{ top }}
      >
        <div className={styles.mobile}>{`Mobile${scrolled}`}</div>
        <div className={styles.tablet}>{`Tablet${scrolled}`}</div>
        <div className={styles.desktop}>{`Desktop${scrolled}`}</div>
      </div>
    );
  }
}

export default ScreenSizeIndicator;
